[
  {
    "eventId": "4001",
    "description": "Wired & OBDII Ignition on periodic time based reporting ",
    "active": true
  },
  {
    "eventId": "4002",
    "description": "Wired & OBDII Ignition off periodic time based reporting ",
    "active": false
  },
  {
    "eventId": "4003",
    "description": "Virtual Ignition on periodic time based reporting ",
    "active": true
  },
  {
    "eventId": "4004",
    "description": "Virtual Ignition off periodic time based reporting ",
    "active": false
  },
  {
    "eventId": "4005",
    "description": "Main battery disconnected periodic reporting ",
    "active": false
  },
  {
    "eventId": "4012",
    "description": "Ignition on periodic distance based reporting ",
    "active": false
  },
  {
    "eventId": "6001",
    "description": "Direction change alert ",
    "active": true
  },
  {
    "eventId": "6002",
    "description": "Speed threshold alert ",
    "active": false
  },
  {
    "eventId": "6003",
    "description": "RPM threshold alert ",
    "active": false
  },
  {
    "eventId": "6005",
    "description": "Mileage threshold exceeded alert ",
    "active": false
  },
  {
    "eventId": "6006",
    "description": "Acceleration threshold alert ",
    "active": false
  },
  {
    "eventId": "6007",
    "description": "Deceleration threshold alert ",
    "active": false
  },
  {
    "eventId": "6008",
    "description": "Main battery threshold alert ",
    "active": false
  },
  {
    "eventId": "6009",
    "description": "Main battery disconnect alert ",
    "active": false
  },
  {
    "eventId": "6010",
    "description": "Main battery reconnect alert ",
    "active": false
  },
  {
    "eventId": "6011",
    "description": "Wired & OBDII Ignition on alert ",
    "active": true
  },
  {
    "eventId": "6012",
    "description": "Wired & OBDII Ignition off alert ",
    "active": false
  },
  {
    "eventId": "6013",
    "description": "Virtual Ignition on alert ",
    "active": false
  },
  {
    "eventId": "6014",
    "description": "Virtual Ignition off alert ",
    "active": false
  },
  {
    "eventId": "6016",
    "description": "Idle threshold violation periodic alert ",
    "active": false
  },
  {
    "eventId": "6017",
    "description": "Towing detected alert ",
    "active": false
  },
  {
    "eventId": "6018",
    "description": "Towing stopped alert ",
    "active": false
  },
  {
    "eventId": "6027",
    "description": "Pre-Sleep Alert Notification ",
    "active": false
  },
  {
    "eventId": "6030",
    "description": "Moving detected ",
    "active": false
  },
  {
    "eventId": "6031",
    "description": "Moving stopped ",
    "active": false
  },
  {
    "eventId": "6032",
    "description": "Park time threshold alert ",
    "active": false
  },
  {
    "eventId": "6035",
    "description": "Accelerometer threshold alert ",
    "active": false
  },
  {
    "eventId": "6071",
    "description": "Motion start wake alert ",
    "active": false
  },
  {
    "eventId": "6073",
    "description": "Periodic alarm wake alert ",
    "active": false
  },
  {
    "eventId": "6076",
    "description": "Voltage wake alert ",
    "active": false
  },
  {
    "eventId": "6090",
    "description": "Battery disconnect wake alert ",
    "active": false
  },
  {
    "eventId": "6091",
    "description": "Low battery disconnect wake alert ",
    "active": false
  },
  {
    "eventId": "6092",
    "description": "Idle threshold violation ",
    "active": false
  },
  {
    "eventId": "6093",
    "description": "Idle state exit (vehicle started moving or ignition was turned off) ",
    "active": false
  },
  {
    "eventId": "6004",
    "description": "Geofence crossing alert ",
    "active": false
  },
  {
    "eventId": "6045",
    "description": "Diagnostic trouble code list change alert",
    "active": false
  }
]
